// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"318":"5d3d7760273bb4e43348","669":"460eee58eba9d234309b","795":"a9eae4d5dced963aae3a","796":"c8c903ac5ba3e9cb20a7","820":"f752ad42e2960be8e66f"}[chunkId] + ".js";
};